import { REGISTRATION_UPDATE } from "../store/types";

export default {
  computed: {
    value() {
      return this.$store.getters.getRegistrationValue(this.attribute);
    },
  },

  methods: {
    update(event) {
      const payload = { [this.attribute]: event.target.value.trim() };

      this.$store.commit(REGISTRATION_UPDATE, { payload });
    },
  },
};
